import { useAuth } from 'modules/auth/hooks/useAuth';

import { StatsContext } from './context';
import { usePrivateStats } from './hooks/usePrivateStats';
import { usePublicStats } from './hooks/usePublicStats';

interface StatsProviderProps {
  children: React.ReactNode;
}

export const StatsProvider = ({ children }: StatsProviderProps) => {
  const { isLoggedIn } = useAuth();

  const privateStats = usePrivateStats();
  const publicStats = usePublicStats();

  return (
    <StatsContext.Provider value={isLoggedIn ? privateStats : publicStats}>
      {children}
    </StatsContext.Provider>
  );
};
